__turbopack_context__.v({
  "className": "markazi_text_478b823a-module__AlKU5a__className",
});
